/**
 * Every currency present across some `{currency: amount}` maps, the platform's own
 * first so the default selection is stable. `[settlement]` when the maps hold none.
 */
export function currenciesOf(maps, settlement) {
  const seen = [];
  (maps || []).forEach((m) => Object.keys(m || {}).forEach((c) => {
    if (!seen.includes(c)) seen.push(c);
  }));
  seen.sort();
  if (settlement && seen.includes(settlement)) {
    return [settlement, ...seen.filter((c) => c !== settlement)];
  }
  return settlement && seen.length === 0 ? [settlement] : seen;
}
